import { Dialog, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import React from "react";

const IndividualGroupModal = (props) => {

	const handleClose = () => {
		props.onClose()
	};
	
	const handleEmployeeClick = (employee) => {
		props.onEmployeeSelected(employee);
	};
	
	return (
		<Dialog
			open={props.group? true : false}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="sm"
		>
			<DialogTitle id="alert-dialog-title">
				{(props.group)? `${props.group.name}` : ""}
			</DialogTitle>
			<DialogContent>
				{(props.group)?
					<Stack direction="column" spacing={2}>
						<Typography>
							<span style={{ fontWeight: "bold", marginRight: "1em" }}>{`Total Employees:`}</span>
							{`${props.group.company_employees.length}`}
						</Typography>
						<Stack direction="column" sx={{ maxHeight: "20em", overflow: "auto" }}>
							{props.group.company_employees.map((employee, i) => {
								return (
									<Typography
										key={`employee_${i}`}
										sx={{ ":hover": { cursor: "pointer" }, margin: "0.5em 0" }}
										onClick={() => { handleEmployeeClick(employee); }}
									>
										<span style={{ fontWeight: "bold", marginRight: "1em" }}>
											{`${employee.firstname} ${employee.lastname}`}
										</span>
										{`${employee.email}`}
									</Typography>
								)
							})}
						</Stack>
					</Stack>
				: <React.Fragment/>
				}
			</DialogContent>
		</Dialog>
	);

}

export default IndividualGroupModal;